import { computed, ref } from 'vue';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { useScheduledMessagesStore } from 'dashboard/stores/scheduledMessages';

export function useScheduledMessages(conversationId) {
  const { t } = useI18n();
  const store = useScheduledMessagesStore();
  const isCreating = ref(false);

  const scheduledMessages = computed(() =>
    store.forConversation(conversationId.value)
  );

  const fetchScheduledMessages = async () => {
    try {
      await store.fetch(conversationId.value);
    } catch {
      useAlert(t('SCHEDULED_MESSAGES.FETCH_ERROR'));
    }
  };

  const createScheduledMessage = async attributes => {
    isCreating.value = true;
    try {
      await store.create({
        conversationId: conversationId.value,
        ...attributes,
      });
      useAlert(t('SCHEDULED_MESSAGES.CREATE_SUCCESS'));
      return true;
    } catch {
      useAlert(t('SCHEDULED_MESSAGES.CREATE_ERROR'));
      return false;
    } finally {
      isCreating.value = false;
    }
  };

  const cancelScheduledMessage = async id => {
    try {
      await store.cancel({ conversationId: conversationId.value, id });
      useAlert(t('SCHEDULED_MESSAGES.CANCEL_SUCCESS'));
    } catch {
      useAlert(t('SCHEDULED_MESSAGES.CANCEL_ERROR'));
    }
  };

  return {
    scheduledMessages,
    isCreating,
    fetchScheduledMessages,
    createScheduledMessage,
    cancelScheduledMessage,
  };
}
